import React from 'react';
import {Spinner} from '@chakra-ui/react';

const LoadingWheel = () => {
  return <Spinner thickness="4px" speed="0.8s" emptyColor="graystone.primary" color="secondary.300" size="xl" />;
};

export default LoadingWheel;
